import React from 'react';
import styles from './MegaMenu.module.css';
import { megaMenuData } from './data';

interface MegaMenuProps {
    menuId: 'send-receive' | 'services';
}
interface MegaMenuItem {
    title: string;
    href: string;
    description: string;
    badge?: string;
}

type MenuId = keyof typeof megaMenuData;

interface MegaMenuProps {
    menuId: MenuId;
}

export const MegaMenu = ({ menuId }: MegaMenuProps) => {
    const data = megaMenuData[menuId];

    return (
        <div className={styles.megaMenu}>
            <div className={styles.megaMenuContent}>
                {data.columns.map((column, colIndex) => (
                    <div key={colIndex} className={styles.megaMenuColumn}>
                        {column.map((item: MegaMenuItem) => {
                            const isActive = item.href && item.href !== '#';

                            if (isActive) {
                                return (
                                    <a
                                        key={item.title}
                                        href={item.href}
                                        className={styles.megaMenuItem}
                                    >
                                        <span className={styles.megaMenuItemTitle}>
                                            {item.title}
                                            {item.badge && (
                                                <span className={styles.badge}>{item.badge}</span>
                                            )}
                                        </span>
                                        <p className={styles.megaMenuItemDesc}>
                                            {item.description}
                                        </p>
                                    </a>
                                );
                            } else {
                                return (
                                    <div
                                        key={item.title}
                                        className={styles.megaMenuItem}
                                        aria-disabled="true"
                                        style={{ cursor: 'default', color: '#999' }}
                                    >
                                        <span className={styles.megaMenuItemTitle}>
                                            {item.title}
                                            {item.badge && (
                                                <span className={styles.badge}>{item.badge}</span>
                                            )}
                                        </span>
                                        <p className={styles.megaMenuItemDesc}>
                                            {item.description}
                                        </p>
                                    </div>
                                );
                            }
                        })}
                    </div>
                ))}
            </div>
        </div>
    );
};
